"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoutoutRequestRefund = exports.MeetGreetRefund = exports.Refund = exports.RefundStatusTypes = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
const functions_1 = require("../functions");
var PaymentItemTypes = functions_1.functions.payments.PaymentItemTypes;
exports.RefundStatusTypes = ['pending', 'refunded', 'canceled'];
class Refund extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsIn(exports.RefundStatusTypes)
], Refund.prototype, "status", void 0);
__decorate([
    toccata_1.validator.IsIn(PaymentItemTypes)
], Refund.prototype, "paymentItemType", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Refund.prototype, "createdAt", void 0);
__decorate([
    toccata_1.validator.IsString()
], Refund.prototype, "intentId", void 0);
__decorate([
    toccata_1.validator.IsObject(),
    toccata_1.validator.IsOptional()
], Refund.prototype, "intent", void 0);
__decorate([
    toccata_1.validator.IsObject(),
    toccata_1.validator.IsOptional()
], Refund.prototype, "payment", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Refund.prototype, "refundedAt", void 0);
__decorate([
    toccata_1.validator.IsObject(),
    toccata_1.validator.IsOptional()
], Refund.prototype, "refund", void 0);
__decorate([
    toccata_1.validator.IsObject(),
    toccata_1.validator.IsOptional()
], Refund.prototype, "canceled", void 0);
exports.Refund = Refund;
class MeetGreetRefund extends Refund {
}
__decorate([
    toccata_1.validator.IsString()
], MeetGreetRefund.prototype, "sessionId", void 0);
__decorate([
    toccata_1.validator.IsString()
], MeetGreetRefund.prototype, "slotId", void 0);
__decorate([
    toccata_1.validator.IsObject()
], MeetGreetRefund.prototype, "slot", void 0);
exports.MeetGreetRefund = MeetGreetRefund;
class ShoutoutRequestRefund extends Refund {
}
__decorate([
    toccata_1.validator.IsString()
], ShoutoutRequestRefund.prototype, "requestId", void 0);
__decorate([
    toccata_1.validator.IsObject()
], ShoutoutRequestRefund.prototype, "request", void 0);
exports.ShoutoutRequestRefund = ShoutoutRequestRefund;
//# sourceMappingURL=payments.js.map